import { endpoints } from '../core/apiConfig';
import config from '../../config/configuration';

export async function getAllBusinessList() {
  try {
    const response = await fetch(`${config.BASE_URL}${endpoints.business.getAllBusiness}`);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch business list:', error);
    return null;
  }
}
export async function getBusinessInfo(businessAalias: string) {
  try {
    if (!businessAalias || businessAalias.length === 0) return null;
    const response = await fetch(
      `${config.BASE_URL}${endpoints.business.getAllBusiness}?businessAlias=${businessAalias}`
    );
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Failed to fetch business list:', error);
    return null;
  }
}
